var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('field-select-module',{attrs:{"board":this.board,"is-print":_vm.isPrint},model:{value:(_vm.form.stdInfo),callback:function ($$v) {_vm.$set(_vm.form, "stdInfo", $$v)},expression:"form.stdInfo"}}),_c('table-custom',{attrs:{"board":_vm.board,"is-print":_vm.isPrint,"controls":false,"multiple":false,"thema":"label","title":"점검내용","tableData":[
      {
        id: 'label',
        title: '이행사항',
        type: 'label',
        align: 'left',
        vertical: 'middle',
      },
      {
        id: 'input1',
        title: '세부내용',
        type: 'string',
        align: 'left',
        vertical: 'middle',
      },
      {
        id: 'input2',
        title: '점검일시',
        type: 'dateArr',
        vertical: 'middle',
      },
      {
        id: 'input3',
        title: '점검결과',
        type: 'textarea',
        placeholder: [
          '안전인력 점검/필요시 개선사항 도출 (문서화)',
          '안전예산 편성· 집행  점검/필요시 개선사항 도출 (문서화)',
          '위협요인 도출/필요시 개선사항 도출 (문서화)',
          '안전계획 점검/필요시 개선사항 도출 (문서화)',
          '업무처리 절차 점검/필요시 개선사항 도출 (문서화)',
          '도급 등 기준과 절차 마련  점검/필요시 개선사항 도출 (문서화)',
          '관계 법령 의무사항 점검/필요시 개선사항 도출 (문서화)',
          '교육대상자 점검/필요시 개선사항 도출 (문서화)',
        ],
        vertical: 'middle',
      },
      {
        id: 'input4',
        title: '조치사항',
        type: 'textarea',
        placeholder: '입력해 주세요',
        vertical: 'middle',
      },
      {
        id: 'input5',
        title: '점검일시',
        type: 'dateArr',
        vertical: 'middle',
      },
      {
        id: 'input6',
        title: '점검결과',
        type: 'textarea',
        placeholder: [
          '안전인력 업무점검 (문서화)',
          '안전예산 집행 점검 (문서화)',
          '위협요인 조치사항 확인 (문서화)',
          '안전계획 이행점검 (문서화)',
          '업무처리절차 이행성과점검 (문서화)',
          '도급 등 이행성과점검 (문서화)',
          '관계 법령 이행사항점검 (문서화)',
          '교육이수점검 (문서화)',
        ],
        vertical: 'middle',
      },
      {
        id: 'input7',
        title: '조치사항',
        type: 'textarea',
        placeholder: '입력해 주세요',
        vertical: 'middle',
      },
    ]},scopedSlots:_vm._u([{key:"doubleHead",fn:function(){return [_c('th',{staticClass:"text-center",staticStyle:{"width":"34%"},attrs:{"colspan":"2"}},[_vm._v("구분")]),_c('th',{staticClass:"text-center",attrs:{"colspan":"3"}},[_vm._v("상반기")]),_c('th',{staticClass:"text-center",attrs:{"colspan":"3"}},[_vm._v("하반기")])]},proxy:true}]),model:{value:(_vm.form.table),callback:function ($$v) {_vm.$set(_vm.form, "table", $$v)},expression:"form.table"}}),_c('file-upload-module',{staticClass:"w-full mt-4",attrs:{"id":"fileList","is-print":_vm.isPrint,"readonly":_vm.board.readonly},model:{value:(_vm.form.fileList),callback:function ($$v) {_vm.$set(_vm.form, "fileList", $$v)},expression:"form.fileList"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }